var exports = {
  "v_": "DiscoveryNavbar.module__navbar___UEZ6TW",
  "Bx": "DiscoveryNavbar.module__leftSection___UEZ6TW",
  "LY": "DiscoveryNavbar.module__leftSurface___UEZ6TW",
  "Gv": "DiscoveryNavbar.module__backButton___UEZ6TW",
  "dc": "DiscoveryNavbar.module__searchTitle___UEZ6TW",
  "$L": "DiscoveryNavbar.module__categoryTabs___UEZ6TW",
  "Wu": "DiscoveryNavbar.module__categoryTab___UEZ6TW",
  "KB": "DiscoveryNavbar.module__categoryTabActive___UEZ6TW" + " " + "DiscoveryNavbar.module__categoryTab___UEZ6TW",
  "uk": "DiscoveryNavbar.module__searchArea___UEZ6TW",
  "rm": "DiscoveryNavbar.module__searchForm___UEZ6TW",
  "qc": "DiscoveryNavbar.module__searchIcon___UEZ6TW",
  "Rt": "DiscoveryNavbar.module__searchInput___UEZ6TW",
};

module.exports = exports;
